import {
  Layout, Menu, Badge, Drawer, Icon, Button, Divider,
} from 'antd';
import { injectGlobal } from 'emotion';
import styled from 'react-emotion/macro';
import {
  width, height, space, color, fontSize, fontWeight, themeGet,
  top, bottom,
} from 'styled-system';

export const BarWrapper = styled(Layout)` &&& {
  & > div {
    ${color}
  }
  flex: none;

  .ant-layout-header {
    ${color}
    ${height}
  }

  .ant-col-6:nth-child(3) > * {
    float: right;
  }

  .ant-col-12 {
    text-align: center;
  }
}`;


export const MenuWrapper = styled(Menu)` &&& {
  ${color}
  ${height}
  font-family: 'proxima-nova', Sans-Serif;
  border-bottom: none;

  .ant-layout-header {
    ${color}
  }

  li > a {
    ${color}
    ${height}
    width: 100%;
    font-weight: 500;
    letter-spacing: 1px;
    font-family: 'proxima-nova', Sans-Serif;
    display: flex;
    align-items: center;
    border-bottom: none;
  }

  .ant-menu-item {
    border-bottom: none;
  }

  .ant-menu-item-active,
  .ant-menu-item-active a,
  .ant-menu-item-selected,
  .ant-menu-item-selected a,
  li:hover,
  li:hover a {
    box-shadow: inset 0 -4px 0 0 white;
    border-bottom: none;
  }

  /* SVG icons from React-Icons - subject to change */
  li > a > svg {
    ${width}
    margin-right: 5px;
  }
}`;

export const ProfileInfo = styled.div`
  display: inline-block;
  vertical-align: middle;
  text-align: right;
  ${color}
  ${space}
  
  & > div {
    line-height: 18px;
  }
`;

export const ProfileText = styled.div`
  ${fontSize}
  ${fontWeight}
`;

export const NotifButtonWrapper = styled(Badge)` &&& {
  ${space}
  button {
    border: none;
    padding: 0;

    .anticon {
      ${fontSize}
      vertical-align: -0.28em;
    }
  }

  sup {
    font-size: 13px;
    transform: scale(.8);
    box-shadow: none;
    background: #080;
  }
}`;

export const HistoryDrawer = styled(Drawer)` &&& {
  z-index: 9999;
  
  .ant-drawer-close {
    z-index: 996;
  }
  .ant-drawer-title {
    line-height: 14px;
  }

  .ant-drawer-content-wrapper {
    height: calc(100vh - ${themeGet('heights.navBarHeight')}) !important;
    bottom: 0;
    ${width}
  }

  .ant-timeline {
    margin-top: 48px;
  }

  .ant-timeline-item-content {
    margin-left: 32px;
  }

  .ant-collapse-header,
  .ant-collapse-content {
    padding: 0;
    font-size: .9em;
  }

  .ant-collapse-item {
    border: none;
  }

  .ant-collapse-content-box {
    padding: 0;
    font-size: .9em;
  }
}`;

export const HistoryDrawerCutOff = styled('div')` &&& {
  width: calc(100% - 40px);
  height: 50px;
  background: #fff;
  position: absolute;
  ${top}
  ${bottom}
  z-index: 995;
}`;

export const HistoryIcon = styled(Icon)` &&& {
  ${color}
}`;

export const HistoryLabel = styled('div')`
  line-height: 1.3;
  margin-bottom: 4px;
`;

export const HistoryEventList = styled('ul')`
  padding-left: 16px;
  li {
    line-height: 1.2;
    margin-bottom: 8px;
  }
`;

export const HistoryClearButton = styled(Button)` &&& {
  ${space}
  ${color}
  position: absolute;
  z-index: 996;
  bottom: -10px;
  right: 8px;
  margin-bottom: 20px;
  &:hover {
    opacity: .8;
  }

  &:disabled {
    border: none;
    background: ${themeGet('colors.greyscale.3')};
    color: ${themeGet('colors.greyscale.1')};
  }
}`;

export const HistoryTriangleBase = styled('div')`
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  cursor: pointer;
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};

  &:hover {
    opacity: .8;
  }
`;

export const HistoryTriangleUp = styled(HistoryTriangleBase)`
  border-bottom: 15px solid ${props => props.disabled ? themeGet('colors.greyscale.3') : themeGet('colors.clientSecondary')};
  margin-bottom: 20px;
  top: 20px;
`;

export const HistoryTriangleDown = styled(HistoryTriangleBase)`
  border-top: 15px solid ${props => props.disabled ? themeGet('colors.greyscale.3') : themeGet('colors.clientSecondary')};
  margin-top: 20px;
  bottom: 20px;
`;

export const DCRPINavBarPopoverStyle = injectGlobal`
  .DCRP-navbar-popover {
    .ant-popover-inner {
      border-radius: 0;
    }
    
    .ant-popover-arrow {
      width: 12px;
      height: 12px;
      top: 3px !important;
      background: #fff;
    }

    .ant-popover-inner-content {
      padding: 0;
      margin: 0;

      .ant-divider {
        margin: 0;
      }

      .ant-menu-item {
        margin: 0 !important;
      }
    }
  }
`;

export const SiteName = styled.div` &&& {
  font-size: 1.8em;
  ${color}
  text-transform: capitalize;
  font-weight: bolder;
  line-height: 1em;
  margin: 0.3em 0 0 0.4em;
  border-radius: 5px;
  padding: 0.2em 0.4em;
  background-color: white;
  font-family: proxima-nova;
}`;


export const LogoGroup = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  img {
    margin-top: 0.2em;
    height: 1.8em;
  }
  line-height: 1px;
  align-self: center;
`;
